import { render, staticRenderFns } from "./RalanCard.vue?vue&type=template&id=f6d00b56&"
import script from "./RalanCard.vue?vue&type=script&lang=js&"
export * from "./RalanCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports